module.exports = __webpack_public_path__ + "img/video.ead67a63.png";